/**
 * This  modal component use for to Delete the recognise fellow
 */
 import { useEffect, useState } from "react";
 import { withRouter } from "react-router-dom";
 import { connect } from "react-redux";
 import Modal from "../../common/Modal";
 import Button from "../../common/Button";
 import "./style.scss";
 import { useHistory } from "react-router-dom";
 import InputField from "../../common/InputField";
 import { makeStyles } from "@material-ui/core/styles";
 import swal from "sweetalert";
 import TextareaField from "../../common/TextAreaField";
 const useStyles = makeStyles((theme) => ({
   input: {
     backgroundColor: "white"  }
 }));
 const UploadDocPopUp = (props) => {
   const {
     onClose,
     action,
     submitData,
   } = props;
   const [errorMessage, setErrorMessage] = useState(false)
   const [fileData, setFileData] = useState();
   useState(false);
   const clickonFileinput = (event) => {
    event.preventDefault();
    let element = document.getElementById("fileUpload-resume");
    element.click();
  };
  const removeFile = (fileType) => {
    if (fileType === "uploadResume") {
      setFileData((user) => {
        return { ...user, ["uploadResume"]: null };
      });
    }
  };
  const handleInputChange = (e) => {
    setFileData((user) => {
      return { ...user, [e.target.name]: e.target.files[0] };
    });
    const newFormData = {
      ...fileData,
      [e.target.name]: e.target.files[0],
    };
    if(newFormData?.uploadResume !== null){
      setErrorMessage(false)
    }
  };

const handleSubmit=()=>{
  if(fileData === undefined || fileData?.uploadResume === null){
    setErrorMessage(true)
  }
  else{
    setErrorMessage(false)
    props.setfileDataParent(fileData)
    setTimeout(() => {
      swal({
        title: "Thank You",
        text: `File Uploaded Successfully`,
        icon: "success",
        // timer: 1500,
        // buttons: false,
      }).then(function () {
        onClose();
      });
    }, 250);
  }
}
   return (
     <div className="add-profile-block submitAction">
       <div className="add-profile-head">
         <h2 style={{display:"contents",fontSize:"30px"}}>
          UPLOAD FILES
         </h2>
       </div>
       <div className="uploadFileBox">
       <div className="fileUpload2 col col-lg-7 col-md-6 col-sm-12 ">
                    <div>
                    <div className="newuserTooltip top-btn">
                      <button
                        onClick={clickonFileinput}
                        className="newUploadBtn popupPositionFix"
                      >
                        CLICK TO UPLOAD
                      </button>
                      <span className="tooltiptext   tooltip-bottom" style={{top:"47px",left:"89px",width:"auto"}}>
                    Upload Document
                  </span>
                  </div>
                      <p
                        className="popupPositionFix2"
                      >
                        <br />
                        <span>Only PNG/JPG/JPEG/PDF and .MP4 files are allowed</span>
                      </p>
                      <div className="fileupload-resume-startup">
                        <input
                          className="resume-upload"
                          type="file"
                          id="fileUpload-resume"
                          required
                          name="uploadResume"
                          onChange={handleInputChange}
                          style={{ display: "none" }}
                        />
                      </div>
                    </div>
                    {fileData && fileData?.uploadResume !== null && (
                      <div style={{ marginBottom: "50px" }} className="messageFilePosFix">
                        <div className="file-name" style={{ float: "left" }}>
                          {fileData?.uploadResume?.name}{" "}
                          <span
                            style={{ marginLeft: "10px" ,cursor:"pointer"}}
                            onClick={() => removeFile("uploadResume")}
                          >
                            {" "}
                            X{" "}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                  {errorMessage && (
                      <div className="login-error-msg errorMessageFix">
                        Please upload a file
                      </div>
                    )}
       </div>
    
       <div className="fileFooterFix messageFileErrorFix">
                <Button
                  onClick={handleSubmit}
                  text="SUBMIT"
                  className="modalButton89 doc-uploadnext"
                ></Button>
              </div>
       </div>
 
   );
 };
 const mapStateToProps = (state) => {
   return {
     updatedStatus: state.AdminMentorViewReducer.updateApplicationStatus.data,
   };
 };
 export default connect(mapStateToProps, {  })(
   withRouter(Modal(UploadDocPopUp))
 );
